<template>
  <div v-if="contactItem.image">
    <div class="img-rounded img-profile my-3" v-bind:style="{'backgroundImage': (contactItem.thumb) ? 'url('+ publicPath + contactItem.thumb +')' : ''}"></div>
  </div>
  <div v-if="!contactItem.image">
    <div class="img-rounded my-3">
      <i class="fa fa-user"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactImage',
  props: ['contactItem', 'publicPath']
}
</script>

<style>
</style>

<style scoped>
</style>
